__turbopack_context__.v({
  "clearButton": "Form-module__y55n2W__clearButton",
  "errorMessage": "Form-module__y55n2W__errorMessage",
  "eyeButton": "Form-module__y55n2W__eyeButton",
  "form": "Form-module__y55n2W__form",
  "inputRow": "Form-module__y55n2W__inputRow",
  "isVisible": "Form-module__y55n2W__isVisible",
  "submitButton": "Form-module__y55n2W__submitButton",
});
